<template>
    <modal v-bind:showModal="showModal" data-backdrop="false" v-bind:size="{'my-col':true,'col-lg-8':true}">
        <div slot="header">
            <label>{{modalHeader}}</label>
        </div>
        <div slot="body">

            <!-- -->
            <div class="row">
                <div class="col-sm-12">

                    <div class="form-group">
                        <label>{{$t("auditconfig_managment.audit_type")}}</label>
                        <input type="text" class="form-control" v-model="auditType">
                    </div>

                    <div class="form-group">
                        <label>{{$t("auditconfig_managment.inf_val")}}</label>
                        <input type="text" class="form-control" v-model="infVal">
                    </div>

                    <div class="form-group">
                        <label>{{$t("auditconfig_managment.id")}}</label>
                        <input type="text" class="form-control" v-model="id">
                    </div>

                </div>
            </div>

        </div>
        <div slot="footer">
            <div class="row">
                <div class="col-md-2"></div>
                <div class="col-md-8">
                    <div v-if="errors.length" class="form-validate-summary alert alert-danger">
                        <ul id="appform-validationsummary">
                            <li :style="{textAlign : (direction ? 'right' : 'left')}" v-for="e in errors">{{e}}</li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-2"></div>
            </div>

            <div class="row">
                <div class="col-md-4"></div>
                <div class="col-md-4"></div>
                <div class="col-md-4">
                    <button class="btn btn-success" @click="submit()"> 
                        {{$t("save")}}
                    </button>
                    <button class="btn btn-default cancelModal"
                            data-dismiss="modal">
                        {{$t("cancel_nested")}}
                    </button>
                </div>
            </div>
        </div>
    </modal>
</template>
<script>
    import Modal from "../../widgets/modal/modal.vue";

    export default {
        props: [
            'showAuditModal',
            'modalData'
        ],
        data() {
            return {
                direction: payload.currentLocale.IsRightToLeft,
                modalHeader: '',
                errors: [],
                auditType: '',
                infVal: '',
                id: ''
            }
        },
        computed: {
            showModal() {
                this.init();

                this.modalHeader = this.modalData.isCreation ? i18n.$t("insert") : i18n.$t("edit");

                if (!this.modalData.isCreation) {
                    this.edit();
                    return this.showAuditModal;
                } else {
                    return this.showAuditModal;
                }
            }
        },
        methods: {
            init() {
                this.auditType = '';
                this.infVal = '';               
                this.id = '';              
                this.errors = [];
            },           
            validation() {
                this.errors = [];
                var result = true;
                debugger;
                if ($.trim(this.auditType).length === 0) {
                    this.errors.push(i18n.$t("auditconfig_managment.audit_type_required"));
                    result = false;
                }
                if ($.trim(this.infVal).length === 0) {
                    this.errors.push(i18n.$t("auditconfig_managment.inf_val_required"));
                    result = false;
                }
                if ($.trim(this.id).length === 0) {
                    this.errors.push(i18n.$t("auditconfig_managment.id_required"));
                    result = false;
                }

                return result;
            },
            submit() {
                if (this.validation()) {

                    var isCreation = this.modalData.isCreation;

                    var url = isCreation ? "api/auditConfig/add" : "api/auditConfig/update";
                    var method = isCreation ? 'POST' : 'PUT';

                    var data = {
                        auditType: this.auditType,
                        infVal: this.infVal,
                        id: this.id                       
                    }

                    if (!isCreation) {
                        data.id = this.id;
                        data.auditType = this.auditType;
                        data.infVal = this.infVal;

                    }

                    var callback = (result) => {
                        $('.cancelModal', this.$el).click();

                        var params = {
                            text: this.$t('messages.sucsses_message'),
                            type: 'information',
                            layout: 'center',
                            timeout: 3000
                        };
                        noty(params);

                        this.modalData.callback();
                    };

                    var that = this;

                    this.doAjaxRequest(url,
                        JSON.stringify(data),
                        callback,
                        function (data) {
                            for (var i = 0; i < data.length; i++) {
                                var item = data[i];
                                for (var j = 0; j < item.Errors.length; j++) {
                                    var errorItem = item.Errors[j];
                                    that.errors.push(i18n.$t(errorItem.ErrorMessage));
                                }
                            }
                        },
                        method);
                }
            },          
            edit() {
                var that = this;
                debugger;
                var auditType = this.modalData.auditType;
                var url = "api/auditConfig/get/" + auditType;

                this.doAjaxRequest(
                    url, {},
                    (data) => {
                        that.auditType = data.AuditType;
                        that.infVal = data.InfVal;
                        that.id = data.Id;                      
                    },"GET");
            },           
            doAjaxRequest(url, data, onSuccess, onFailure, method) {
                let ajaxConfig = {
                    url: url,
                    data: data,
                    dataType: "json",

                    contentType: "application/json;charset=utf-8"
                };
                ajaxConfig.beforeSend = (xhr) => {
                    xhr.setRequestHeader("__RequestVerificationToken", $("[name='__RequestVerificationToken']").val());
                };
                if (method) {
                    ajaxConfig.method = method;
                }
                $.ajax(ajaxConfig)
                    .done((result) => {
                        if (typeof onSuccess === 'function')
                            onSuccess(result);
                    }).error((error) => {
                        if (typeof onFailure === 'function') {

                            var response = null;

                            if (error.status == 400) {
                                response = JSON.parse(error.responseText);
                                onFailure(response);
                            }
                        }
                    });
            }
        },
        mounted() {         
         
        },
        created() {
        },
        components: {
            Modal
        }
    }

</script>
